/* eslint-disable react/prop-types */
import { INPUT_VARIANT } from "../const";
import { ANT_FormItem } from "../styles";
import { useVocab, keepBlankLabelSpace } from "@/hooks/useVocab";

const FormItem = ({
    id,
    label,
    className = "", // use dark-form-item for dark bg
    minWidth,
    margin = "default",
    children,
    layout = "vertical", // horizontal, vertical, inline
    colon=false,
    wrapperCol,
    labelPostion, // only have label-right
    rootClassName,
    // Site label renames (legacy Vocab()): a text label is swapped for its
    // Vocabulary replacement, matched on the label or the field name.
    // vocabFieldName defaults to `name`; skipVocab keeps the label as written
    // for a field that only shares its text with a renamed one.
    vocabFieldName,
    skipVocab = false,
    ...rest
}) => {
    const vocab = useVocab();
    const displayLabel = skipVocab
        ? label
        : keepBlankLabelSpace(label, vocab(label, vocabFieldName ?? rest.name));

    return (
        <ANT_FormItem
            layout={layout}
            // controlId={id}
            className={className}
            minWidth={minWidth}
            margin={margin}
            label={displayLabel}
            colon={colon}
            rootClassName={labelPostion == "label-right" ? "form-item-label-right":""}
            {...rest}
        >
            {children}
        </ANT_FormItem>
    );
};
export default FormItem;

